<template>
  <div style="height: 100%; background: #253746;">
    <Header></Header>
    <div class="signup tc">
      <p class="fb tc f20 pt30 mb10">RedWealth</p>
      <el-input v-model="account" placeholder="请输入邮箱" prefix-icon="el-icon-user" type="text"></el-input>
      <el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-unlock" type="password" show-password></el-input>
      <el-input v-model="password2" placeholder="确认密码" prefix-icon="el-icon-unlock" type="password" show-password></el-input>
      <div style='text-align: right'><span style='margin-right: 40px' @click='login'>已有账号，返回登录</span></div>
      <el-button class="co-f mt20" @click="signup">注册</el-button>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      account: '',
      password: '',
      password2: ''
    }
  },
  components: { Header },
  mounted () { },
  methods: {
    login () {
      this.$router.push({name: 'Login'})
    },
    signup () {
      if (this.account === '') {
        this.$message({type: 'error', message: '请输入邮箱！'})
        return
      }
      const regEmail = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
      if (!regEmail.test(this.account)) {
        this.$message({type: 'error', message: '请输入正确邮箱！'})
        return
      }
      if (this.password === '') {
        this.$message({type: 'error', message: '请输入密码！'})
        return
      }
      if (this.password !== this.password2) {
        this.$message({type: 'error', message: '两次输入密码不同！'})
        return
      }
      // this.$router.push({name: 'KnowYou'})
      const url = this.$api.SignUp
      // // {gq1 123456}
      const params = {
        "email": this.account,
        "password": this.password,
        "is_active": true,
        "is_superuser": false,
        "is_verified": false
      }
      this.$http.post(url, params, {}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          this.$message({type: 'success', message: '注册成功！'})
          this.$router.push({name: 'Login'})
         }
      })
    }
   }
}
</script>

<style scoped>
.signup{
   width: 530px;
   height: 405px;
   border-radius: 20px;
   background: #fff;
   margin: 120px auto;
}
.el-input{
  width: 440px;
  height: 38px;
  line-height: 38px;
  margin: 20px auto;
}
.el-button{
  width: 440px;
  background: #e90a5b;
  border-color: #e90a5b;
}
</style>



// WEBPACK FOOTER //
// src/components/signup.vue